export type InsertInvitationTemplateVariable = (token: string) => void;

export type InvitationTemplateVariable = {
  token: string;
  descriptionKey: string;
  defaultDescription: string;
};

export const INVITATION_TEMPLATE_VARIABLES: InvitationTemplateVariable[] = [
  {
    token: '*|groupname|*',
    descriptionKey: 'bulkInvite.variables.groupname',
    defaultDescription:
      'your firm Name or advisor Name (you choose this later)',
  },
  {
    token: '*|signature|*',
    descriptionKey: 'bulkInvite.variables.signature',
    defaultDescription: 'your signature (you choose this later)',
  },
  {
    token: '*|salutation|*',
    descriptionKey: 'bulkInvite.variables.salutation',
    defaultDescription: 'your salutation (you choose this later)',
  },
  {
    token: '*|personalMessage|*',
    descriptionKey: 'bulkInvite.variables.personalMessage',
    defaultDescription:
      'your custom message (this can be added when inviting a client)',
  },
  {
    token: '*|investorname|*',
    descriptionKey: 'bulkInvite.variables.investorname',
    defaultDescription: "your client's name",
  },
  {
    token: '*|username|*',
    descriptionKey: 'bulkInvite.variables.username',
    defaultDescription: "your client's username",
  },
];

/** Matches invitation merge tags like *|salutation|* */
export const INVITATION_MERGE_TAG_PATTERN = /\*\|[a-zA-Z]+\|\*/;
